
import axios from "axios";
import { store } from '../store';
import {router} from "../helpers";
import {i18n} from "../i18n";

export const userService = {
    login,
    logout,
    register,
    addDependant,
    getDependants,
    updateDependant,
    updateSelf,
    agreeTerms,
    instantActivate,
    completeWelcome,
    completeAffiliateWelcome,
    completeTooltips,
    completeTestscan,
    completeInviteMembers,
    completeInvitePartners
};

function agreeTerms() {
    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient.get('/sanctum/csrf-cookie').then(() => {
        return apiClient
            .post('/api/users/self/agree-terms')
            .then(response => {
                if (response.status === 200) {
                    store.dispatch('alert/success', 'You have successfully agreed to the terms and conditions', {root: true});
                }
                return response.data.data;

            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    })
}

function login(email, password) {

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient.get('/sanctum/csrf-cookie').then(() => {
        return apiClient
            .post('/login', {
                email: email,
                password: password
            })
            .then(response => {

                // login successful
                if (response.status === 200 && response.data) {

                    store.dispatch('alert/clear', {root: true});

                    let user = response.data.data

                    store.commit('loggedIn')

                    if ((!user.bundle_claimed_at && user.membership) || user.bundle_due) {

                        let apiClient = axios.create({
                            baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                            headers: {'Accept-Language': i18n.locale}
                        });

                        apiClient
                            .get('/api/products/slug/free-bundle')
                            .then(response => {
                                let product = response.data.data
                                store.dispatch('basket/addSilent', {product}).then(() => {
                                    store.dispatch('alert/gift', 'You have a FREE bundle in your basket. Please checkout to claim.', {root: true});
                                })
                            })
                            .catch(error => {
                                console.log(error)
                            })
                    }
                }

                return response.data.data;
            })
            .catch(function (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    if (error.response.status === 422) {
                        // auto logout if 401 response returned from api
                        logout();
                        //store.commit('loggedOut')
                        //return 'incorrect email or password';
                        return Promise.reject('incorrect email or password');
                        //location.reload();
                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else if (error.message) {
                    // Something happened in setting up the request that triggered an Error
                    console.log(error.message);
                } else {
                    // The login was rejected due to incorrect role
                    return Promise.reject(error);
                }
            });
    })
}

function logout() {

    // call commit directly as no need for asynchronicity
    store.commit('loggedOut')
    store.commit('account/logout')
    store.commit('basket/clear')

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient.get('/sanctum/csrf-cookie').then(() => {
        return apiClient
            .post('/logout')
            .then(response => {
                console.log(response.status)
                // logout successful
                if (response.status === 204) {
                    console.log(router.currentRoute.name)
                    if (router.currentRoute.name !== 'login') {
                        router.push({name: 'login'})
                    }
                }

                return Promise.resolve()
            })
            .catch(function (error) {
                console.log(error)
                return Promise.reject(error);
            });
    })
}

function register(name, email, email_confirmation, mobile, address1, address2, town, county, postcode, country, password, password_confirmation, organisations, makeTagsPublic, recaptchaToken, terms, brand) {

    let sms = mobile.replace('+440', '+44')

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient.get('/sanctum/csrf-cookie').then(() => {
        return apiClient
            .post('/register', {
                name: name,
                email: email,
                email_confirmation: email_confirmation,
                mobile: sms,
                address1: address1,
                address2: address2,
                town: town,
                county: county,
                postcode: postcode,
                country: country,
                password: password,
                password_confirmation: password_confirmation,
                organisations: organisations,
                make_tags_public: makeTagsPublic,
                recaptcha_token: recaptchaToken,
                terms: terms,
                brand: brand
            })
            .then(response => {

                if (response.status === 201 && response.data) {
                    if (response.data.data.roles && response.data.data.roles.includes('user')) {
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        //localStorage.setItem('user', JSON.stringify(response.data));
                        store.commit('loggedIn')
                        //router.push('/verify');
                    } else {
                        console.log('not authorised')
                        return Promise.reject('not authorised');
                    }
                }

                return response.data.data;
            })
            .catch(function (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                    if (error.response.status === 422) {

                        // store server side validation errors
                        return store.dispatch('validationErrors', error.response.data.errors, {root: true}).then(response => {
                            return Promise.reject('check form for errors');
                        });

                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else if (error.message) {
                    // Something happened in setting up the request that triggered an Error
                    console.log(error.message);
                } else {
                    // The login was rejected due to incorrect role
                    return Promise.reject(error);
                }
            });
    });
}

function instantActivate(codeString, name, email, email_confirmation, mobile, password, password_confirmation, recaptchaToken, terms, brand) {

    let sms = mobile.replace('+440', '+44')

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale}
    });

    return apiClient.get('/sanctum/csrf-cookie').then(() => {
        return apiClient
            .post('/api/tags/instant-activate', {
                name: name,
                email: email,
                email_confirmation: email_confirmation,
                mobile: sms,
                password: password,
                password_confirmation: password_confirmation,
                recaptcha_token: recaptchaToken,
                terms: terms,
                qr_code: codeString,
                brand: brand
            })
            .then(response => {

                if (response.status === 201 && response.data) {
                    if (response.data.data.roles && response.data.data.roles.includes('user')) {
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        //localStorage.setItem('user', JSON.stringify(response.data));
                        store.commit('loggedIn')
                        //router.push('/verify');
                    } else {
                        console.log('not authorised')
                        return Promise.reject('not authorised');
                    }
                }

                return response.data.data;
            })
            .catch(function (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                    if (error.response.status === 422) {

                        // store server side validation errors
                        return store.dispatch('validationErrors', error.response.data.errors, {root: true}).then(response => {
                            return Promise.reject('check form for errors');
                        });

                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else if (error.message) {
                    // Something happened in setting up the request that triggered an Error
                    console.log(error.message);
                } else {
                    // The login was rejected due to incorrect role
                    return Promise.reject(error);
                }
            });
    });
}

function addDependant(name, relationship, organisations, makeTagsPublic, school, brand) {

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .post('/api/dependants', {
            name: name,
            relationship: relationship,
            organisations: organisations,
            make_tags_public: makeTagsPublic,
            school: school,
            brand: brand
        })
        .then(response => {

            if (response.status === 201 && response.data) {
                //store.dispatch('alert/success', 'Dependant added', { root: true });
                return response.data;
            }


        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                // console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                if (error.response.status === 422) {

                    // store server side validation errors
                    return store.dispatch('validationErrors', error.response.data.errors, { root: true }).then(response => {
                        return Promise.reject('check form for errors');
                    });

                }
                else {
                    return Promise.reject(error);
                }
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The request was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}

function updateDependant(localEditedItem) {

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .patch('/api/dependants/' + localEditedItem.id, {
            name: localEditedItem.name,
            relationship: localEditedItem.relationship,
            organisations: localEditedItem.organisations,
            make_tags_public: localEditedItem.make_tags_public
        })
        .then(response => {

            // registration successful if there's a jwt token in the response
            if (response.status === 200 && response.data) {
                //store.dispatch('alert/success', 'Dependant added', { root: true });
                return response.data;
            }


        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                // console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                if (error.response.status === 422) {

                    // store server side validation errors
                    return store.dispatch('validationErrors', error.response.data.errors, { root: true }).then(response => {
                        return Promise.reject('check form for errors');
                    });

                }
                else {
                    return Promise.reject(error);
                }
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The request was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}

function getDependants() {

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .get('/api/dependants')
        .then(response => {

            if (response.status === 200 && response.data) {

                store.dispatch('account/loadDependants', response.data, { root: true }).then(response => {
                    console.log("Loaded dependants")
                });

                return response.data;

            }


        })
        .catch(function (error) {

            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);

            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The request was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}

function updateSelf(name, email, email1, email2, mobile, password, organisations, address1, address2, town, county, postcode, country, make_tags_public, preferred_language) {

    let sms = mobile.replace('+440', '+44')

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .patch('/api/users/self', {
            name: name,
            email: email,
            email1: email1 !== '' ? email1 : null,
            email2: email2 !== '' ? email2 : null,
            mobile: sms,
            password: password,
            organisations: organisations,
            address1: address1,
            address2: address2,
            town: town,
            county: county,
            postcode: postcode,
            country: country,
            make_tags_public: make_tags_public,
            preferred_language: preferred_language
        })
        .then(response => {

            if (response.status === 200 && response.data) {

                // update local storage
                // let user = JSON.parse(localStorage.getItem('user'));
                // user.name = response.data.data.name
                // user.mobile = response.data.data.mobile
                // user.email = response.data.data.email
                // user.organisations = response.data.data.organisations
                // localStorage.setItem('user', JSON.stringify(user));

                return response.data.data;
            }


        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                // console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                if (error.response.status === 422) {

                    // store server side validation errors
                    return store.dispatch('validationErrors', error.response.data.errors, { root: true }).then(response => {
                        return Promise.reject('check form for errors');
                    });

                }
                else {
                    return Promise.reject(error);
                }
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The request was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}

function completeWelcome() {
    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        withCredentials: true,
    });

    return apiClient.get('/sanctum/csrf-cookie').then(() => {
        return apiClient
            .patch('/api/users/self/complete-welcome')
            .then(response => {

                if (response.status === 200 && response.data) {

                    return response.data.data;
                }


            })
            .catch(function (error) {
                if (error.response) {
                    return Promise.reject(error);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else if (error.message) {
                    // Something happened in setting up the request that triggered an Error
                    console.log(error.message);
                } else {
                    // The request was rejected due to incorrect role
                    return Promise.reject(error);
                }
            });
    })
}

function completeAffiliateWelcome() {
    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        withCredentials: true,
    });

    return apiClient.get('/sanctum/csrf-cookie').then(() => {
        return apiClient
            .patch('/api/users/self/complete-affiliate-welcome')
            .then(response => {

                if (response.status === 200 && response.data) {

                    return response.data.data;
                }


            })
            .catch(function (error) {
                if (error.response) {
                    return Promise.reject(error);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else if (error.message) {
                    // Something happened in setting up the request that triggered an Error
                    console.log(error.message);
                } else {
                    // The request was rejected due to incorrect role
                    return Promise.reject(error);
                }
            });
    })
}

function completeTooltips() {
    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        withCredentials: true,
    });

    return apiClient.get('/sanctum/csrf-cookie').then(() => {
        return apiClient
            .patch('/api/users/self/complete-tooltips')
            .then(response => {

                if (response.status === 200 && response.data) {

                    return response.data.data;
                }


            })
            .catch(function (error) {
                if (error.response) {
                    return Promise.reject(error);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else if (error.message) {
                    // Something happened in setting up the request that triggered an Error
                    console.log(error.message);
                } else {
                    // The request was rejected due to incorrect role
                    return Promise.reject(error);
                }
            });
    })
}

function completeTestscan() {
    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        withCredentials: true,
    });

    return apiClient.get('/sanctum/csrf-cookie').then(() => {
        return apiClient
            .patch('/api/users/self/complete-testscan')
            .then(response => {

                if (response.status === 200 && response.data) {

                    return response.data.data;
                }


            })
            .catch(function (error) {
                if (error.response) {
                    return Promise.reject(error);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else if (error.message) {
                    // Something happened in setting up the request that triggered an Error
                    console.log(error.message);
                } else {
                    // The request was rejected due to incorrect role
                    return Promise.reject(error);
                }
            });
    })
}

function completeInviteMembers() {
    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        withCredentials: true,
    });

    return apiClient.get('/sanctum/csrf-cookie').then(() => {
        return apiClient
            .patch('/api/users/self/members-invited')
            .then(response => {

                if (response.status === 200 && response.data) {

                    return response.data.data;
                }


            })
            .catch(function (error) {
                if (error.response) {
                    return Promise.reject(error);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else if (error.message) {
                    // Something happened in setting up the request that triggered an Error
                    console.log(error.message);
                } else {
                    // The request was rejected due to incorrect role
                    return Promise.reject(error);
                }
            });
    })
}

function completeInvitePartners() {
    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        withCredentials: true,
    });

    return apiClient.get('/sanctum/csrf-cookie').then(() => {
        return apiClient
            .patch('/api/users/self/partners-invited')
            .then(response => {

                if (response.status === 200 && response.data) {

                    return response.data.data;
                }


            })
            .catch(function (error) {
                if (error.response) {
                    return Promise.reject(error);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else if (error.message) {
                    // Something happened in setting up the request that triggered an Error
                    console.log(error.message);
                } else {
                    // The request was rejected due to incorrect role
                    return Promise.reject(error);
                }
            });
    })
}
